// extracted by mini-css-extract-plugin
module.exports = {"clamped":"ExpandableText-module__clamped___13fUT"};